import React from 'react'
import { SvgIcon } from '@mui/material'

export function CameraOffIcon() {
  return (
    <SvgIcon
      viewBox="0 0 64 64"
      sx={{ color: 'error.main', width: '64px', height: '64px' }}
    >
      <g clipPath="url(#CameraOffIconUrl)">
        <path
          fill="#E6494F"
          d="M25.493 21.333 20.16 16 9.093 4.96l-3.76 3.76 7.28 7.28h-1.946A2.674 2.674 0 0 0 8 18.667v26.666C8 46.8 9.2 48 10.667 48h32c.56 0 1.04-.213 1.466-.48l8.48 8.48 3.76-3.76-23.626-23.627-7.254-7.28Zm-12.16 21.334V21.333h4.614L39.28 42.667H13.333ZM40 21.333v6.96l16 16v-26.96L45.333 28v-9.333c0-1.467-1.2-2.667-2.666-2.667h-14.96l5.333 5.333H40Z"
        />
      </g>
      <defs>
        <clipPath id="CameraOffIconUrl">
          <path fill="#fff" d="M0 0h64v64H0z" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}
